export default [
  // Indicadores (Dashboard KPIs)
  {
    path: '/privacy/indicators',
    name: 'privacy-indicators-list',
    component: () => import('@/views/privacy/indicators/List.vue'),
    meta: {
      module: 'privacy-indicators',
      action: 'view',
      pageTitle: 'Privacy Indicators',
      breadcrumb: [
        {
          text: 'Indicators',
        },
        {
          text: 'Dashboard',
          active: true,
        },
      ],
    },
  },

  // Tratamientos (RAT - Registro de Actividades de Tratamiento)
  {
    path: '/privacy/treatment',
    name: 'privacy-treatment-list',
    component: () => import('@/views/privacy/treatment/list/List.vue'),
    meta: {
      module: 'privacy-treatment',
      action: 'view',
      pageTitle: 'Record of Processing Activities (RPA)',
      breadcrumb: [
        {
          text: 'Treatments',
        },
        {
          text: 'List',
          active: true,
        },
      ],
    },
  },
  {
    path: '/privacy/treatment/add',
    name: 'privacy-treatment-add',
    component: () => import('@/views/privacy/treatment/add/Add.vue'),
    meta: {
      module: 'privacy-treatment',
      action: 'create',
      pageTitle: 'Add Treatment',
      breadcrumb: [
        {
          text: 'Treatments',
          to: '/privacy/treatment',
        },
        {
          text: 'Add',
          active: true,
        },
      ],
    },
  },
  {
    path: '/privacy/treatment/edit/:id',
    name: 'privacy-treatment-edit',
    component: () => import('@/views/privacy/treatment/edit/Edit.vue'),
    meta: {
      module: 'privacy-treatment',
      action: 'edit',
      pageTitle: 'Edit Treatment',
      breadcrumb: [
        {
          text: 'Treatments',
          to: '/privacy/treatment',
        },
        {
          text: 'Edit',
          active: true,
        },
      ],
    },
  },

  // Análisis de Riesgo Inherente (ARI)
  {
    path: '/privacy/inherent-risk',
    name: 'privacy-inherent-risk-list',
    component: () => import('@/views/privacy/inherentRisk/list/List.vue'),
    meta: {
      module: 'privacy-inherent-risk',
      action: 'view',
      pageTitle: 'Inherent Risk Analysis',
      breadcrumb: [
        {
          text: 'Inherent Risk Analysis',
        },
        {
          text: 'List',
          active: true,
        },
      ],
    },
  },
  {
    path: '/privacy/inherent-risk/add',
    name: 'privacy-inherent-risk-add',
    component: () => import('@/views/privacy/inherentRisk/add/Add.vue'),
    meta: {
      module: 'privacy-inherent-risk',
      action: 'create',
      pageTitle: 'Add Inherent Risk Analysis',
      breadcrumb: [
        {
          text: 'Inherent Risk Analysis',
          to: '/privacy/inherent-risk',
        },
        {
          text: 'Add',
          active: true,
        },
      ],
    },
  },
  {
    path: '/privacy/inherent-risk/edit/:id',
    name: 'privacy-inherent-risk-edit',
    component: () => import('@/views/privacy/inherentRisk/edit/Edit.vue'),
    meta: {
      module: 'privacy-inherent-risk',
      action: 'edit',
      pageTitle: 'Edit Inherent Risk Analysis',
      breadcrumb: [
        {
          text: 'Inherent Risk Analysis',
          to: '/privacy/inherent-risk',
        },
        {
          text: 'Edit',
          active: true,
        },
      ],
    },
  },

  // Análisis de Riesgo Residual (ARR)
  {
    path: '/privacy/residual-risk',
    name: 'privacy-residual-risk-list',
    component: () => import('@/views/privacy/residualRisk/list/List.vue'),
    meta: {
      module: 'privacy-residual-risk',
      action: 'view',
      pageTitle: 'Residual Risk Analysis',
      breadcrumb: [
        {
          text: 'Residual Risk Analysis',
        },
        {
          text: 'List',
          active: true,
        },
      ],
    },
  },
  {
    path: '/privacy/residual-risk/add',
    name: 'privacy-residual-risk-add',
    component: () => import('@/views/privacy/residualRisk/add/Add.vue'),
    meta: {
      module: 'privacy-residual-risk',
      action: 'create',
      pageTitle: 'Add Residual Risk Analysis',
      breadcrumb: [
        {
          text: 'Residual Risk Analysis',
          to: '/privacy/residual-risk',
        },
        {
          text: 'Add',
          active: true,
        },
      ],
    },
  },
  {
    path: '/privacy/residual-risk/edit/:id',
    name: 'privacy-residual-risk-edit',
    component: () => import('@/views/privacy/residualRisk/edit/Edit.vue'),
    meta: {
      module: 'privacy-residual-risk',
      action: 'edit',
      pageTitle: 'Edit Residual Risk Analysis',
      breadcrumb: [
        {
          text: 'Residual Risk Analysis',
          to: '/privacy/residual-risk',
        },
        {
          text: 'Edit',
          active: true,
        },
      ],
    },
  },

  // Mapa de Riesgos
  {
    path: '/privacy/risk-map',
    name: 'privacy-risk-map-list',
    component: () => import('@/views/privacy/riskMap/List.vue'),
    meta: {
      module: 'privacy-risk-map',
      action: 'view',
      pageTitle: 'Risks Map',
      breadcrumb: [
        {
          text: 'Risks Map',
        },
        {
          text: 'List',
          active: true,
        },
      ],
    },
  },

  // Brechas (GAP - Análisis de brechas Ley 21.719)
  {
    path: '/privacy/gap',
    name: 'privacy-gap-list',
    component: () => import('@/views/privacy/gap/list/List.vue'),
    meta: {
      module: 'privacy-gap',
      action: 'view',
      pageTitle: 'Gaps (Law 21.719)',
      breadcrumb: [
        {
          text: 'Gaps',
        },
        {
          text: 'List',
          active: true,
        },
      ],
    },
  },
  {
    path: '/privacy/gap/add',
    name: 'privacy-gap-add',
    component: () => import('@/views/privacy/gap/add/Add.vue'),
    meta: {
      module: 'privacy-gap',
      action: 'create',
      pageTitle: 'Add Gap Evaluation',
      breadcrumb: [
        {
          text: 'Gaps',
          to: '/privacy/gap',
        },
        {
          text: 'Add',
          active: true,
        },
      ],
    },
  },
  {
    path: '/privacy/gap/edit/:id',
    name: 'privacy-gap-edit',
    component: () => import('@/views/privacy/gap/edit/Edit.vue'),
    meta: {
      module: 'privacy-gap',
      action: 'edit',
      pageTitle: 'Edit Gap Evaluation',
      breadcrumb: [
        {
          text: 'Gaps',
          to: '/privacy/gap',
        },
        {
          text: 'Edit',
          active: true,
        },
      ],
    },
  },

  // Canal ARSOPB+L
  {
    path: '/privacy/arsopbl',
    name: 'privacy-arsopbl-list',
    component: () => import('@/views/privacy/arsopbl/list/List.vue'),
    meta: {
      module: 'privacy-arsopbl-list',
      action: 'view',
      pageTitle: 'ARSOPB+L Channel',
      breadcrumb: [
        {
          text: 'ARSOPB+L',
        },
        {
          text: 'List',
          active: true,
        },
      ],
    },
  },
  {
    path: '/privacy/arsopbl/detail/:id',
    name: 'privacy-arsopbl-detail',
    component: () => import('@/views/privacy/arsopbl/detail/Detail.vue'),
    meta: {
      module: 'privacy-arsopbl-list',
      action: 'view',
      pageTitle: 'ARSOPB+L Detail',
      breadcrumb: [
        {
          text: 'ARSOPB+L',
          to: '/privacy/arsopbl',
        },
        {
          text: 'Detail',
          active: true,
        },
      ],
    },
  },
  {
    path: '/privacy/arsopbl/templates',
    name: 'privacy-arsopbl-templates',
    component: () => import('@/views/privacy/arsopbl/templates/Templates.vue'),
    meta: {
      module: 'privacy-arsopbl-templates',
      action: 'view',
      pageTitle: 'Response Templates',
      breadcrumb: [
        {
          text: 'ARSOPB+L',
          to: '/privacy/arsopbl',
        },
        {
          text: 'Templates',
          active: true,
        },
      ],
    },
  },
]
